import { Timestamp } from "firebase/firestore/lite";

export interface DbBusinessMembershipTemplate {
  id: string;
  name: string;
  price: number;
  mandatory_advance_percentage: DbMembershipMandatoryAdvancePercentage;
  image_url?: string | null;
  business_id: string;
  created_at: Timestamp;
  description: string;
  duration: DbMembershipDuration;
  type: DbMembershipType;
  status: DbMembershipStatus;
  benefit_amount?: number | null;
  services2: DbMembershipService[];
  updated_at?: Timestamp;
}

export interface DbBusinessMembership {
  id: string;
  name: string;
  price: number;
  image_url?: string;
  business_id: string;
  created_at: Timestamp;
  start_at?: Timestamp;
  expiry: Timestamp;
  type: DbMembershipType;
  benefit_amount?: number;
  services?: DbMembershipService[];
  used_benefit_amount?: number;
  membership_template_id: string;
  payments: DbMembershipPayment[];
  platform_fees: number;
  business_payment_amount: number;
  user_id: string;
}

export interface DbMembershipService {
  service_id: string;
  total_count: number;
  used_count?: number;
}

export interface DbMembershipPayment {
  amount: number;
  created_at: Timestamp;
  payment_id?: string;
  type: DbMembershipPaymentType;
  business_payee_id?: string;
}

export interface APIMembershipPricing {
  price: number;
  platform_fees: number;
  min_purchase_amount: number;
}

export enum DbMembershipDuration {
  one_week = "1_week",
  two_weeks = "2_weeks",
  one_month = "1_month",
  two_months = "2_months",
  three_months = "3_months",
  four_months = "4_months",
  six_months = "6_months",
  eight_months = "8_months",
  one_year = "1_year",
  eighteen_months = "18_months",
  two_years = "2_years",
  five_years = "5_years",
}

export enum DbMembershipType {
  service = "service",
  price = "price",
}

export enum DbMembershipStatus {
  enable = "enable",
  disable = "disable",
  deleted = "deleted",
}

export enum DbMembershipPaymentType {
  pg = "pg",
  cash = "cash",
  businessUPI = "businessUPI",
}

export enum DbMembershipMandatoryAdvancePercentage {
  ten = 10,
  twenty = 20,
  thirty = 30,
  forty = 40,
  fifty = 50,
  sixty = 60,
  seventy = 70,
  eighty = 80,
  ninety = 90,
  hundred = 100,
}
